import React from 'react'

import { ChapterManageList } from '@features/story/components/ChapterManageList'
import { ChapterReaderType } from '@models/chapter/ChapterReaderType'
import { SortEnum } from '@interfaces/SortEnum'
import { Loading } from '@components/Loading'
import { ChapterGroupItemProps } from './interface'

export function ChapterGroupItem({
  data,
  bookId,
  page,
  totalChapter,
  bookName,
  bookType,
  bookCategory,
  bookReadPromotionDetail,
  sorter,
  isLoading,
  isOwner,
  isDrawer,
  isManga,
  isSelect,
  selectedChapters,
  handleSelectChapter,
  canAction,
}: ChapterGroupItemProps) {
  return (
    <div className='max-h-[700px]'>
      {isLoading ? (
        <Loading className='mx-auto' />
      ) : (
        data
          ?.sort((a, b) =>
            sorter === SortEnum.ASC ? a.order - b.order : b.order - a.order
          )
          .map((item: ChapterReaderType, index: number) => (
            <ChapterManageList
              key={item.id}
              data={item}
              bookId={bookId}
              isOwner={isOwner}
              bookName={bookName}
              bookCategory={bookCategory}
              order={
                sorter === SortEnum.ASC
                  ? (page - 1) * 50 + (index + 1)
                  : Math.min(page * 50, totalChapter) - index
              }
              isSelect={isSelect}
              isDrawer={isDrawer}
              isManga={isManga}
              canAction={canAction}
              bookType={bookType}
              selectedChapters={selectedChapters}
              handleSelectChapter={handleSelectChapter}
              bookReadPromotionDetail={bookReadPromotionDetail}
            />
          ))
      )}
    </div>
  )
}
